type Listener = () => void;
const openDialogs = new Set<string>();
const listeners = new Set<Listener>();
let autoDialogQueue: Promise<void> = Promise.resolve();
const pendingDialogs = new Map<string, Promise<unknown>>();

export function setAutoDialogOpen(id: string, open: boolean) {
  if (open) openDialogs.add(id); else openDialogs.delete(id);
  listeners.forEach((listener) => listener());
}
export function hasBlockingAutoDialog(except?: string) {
  return [...openDialogs].some((id) => id !== except);
}
export function subscribeAutoDialogChange(listener: Listener) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
export function runAutoDialog<T>(id: string, task: () => Promise<T>): Promise<T> {
  const pending = pendingDialogs.get(id);
  if (pending) return pending as Promise<T>;
  const previous = autoDialogQueue;
  let release!: () => void;
  autoDialogQueue = new Promise<void>((resolve) => { release = resolve; });
  const run = previous.then(async () => {
    setAutoDialogOpen(id, true);
    try { return await task(); }
    finally { setAutoDialogOpen(id, false); release(); }
  });
  pendingDialogs.set(id, run);
  void run.then(() => pendingDialogs.delete(id), () => pendingDialogs.delete(id));
  return run;
}
